/**
 * Container Flow enum
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum CONTAINER_FLOW {
	COLUMN = "column",
	ROW = "row"
}

export type CONTAINER_FLOW_string = keyof typeof CONTAINER_FLOW;

export const CONTAINER_FLOW_default: CONTAINER_FLOW_string = "COLUMN";

export const CONTAINER_FLOW_opts = {
	column: {
		icon: "mdi/view-sequential"
	},
	row: {
		icon: "mdi/view-column"
	}
};
